export enum EvaluationMethod {
    all = "all",
    any = "any",
}